import { useCallback } from "react";

import { useDeferredResourceQuery } from "@/hooks/use-deferred-resource";
import { orpc } from "@/utils/orpc.client";

import { getSimilarArtistsQueryOptions } from "./similar-artists-query";

/** Similar artists for the artist page (SSR-prefetched deferred resource). */
export function useSimilarArtists(artistId: string) {
  const computeSimilarArtistsResource = useCallback(
    () => orpc.music.computeSimilarArtistsResource.call({ id: artistId }),
    [artistId],
  );
  const { query, value } = useDeferredResourceQuery({
    queryOptions: getSimilarArtistsQueryOptions(artistId),
    compute: computeSimilarArtistsResource,
  });

  return {
    artists: value ?? [],
    isLoading: query.isLoading || query.data?.status === "pending",
  };
}
